/**
 * @fileoverview gRPC-Web generated client stub for mlmbox.client.binary
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.28.2
// source: mlmbox/client/binary/binary.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb'; // proto import: "google/protobuf/empty.proto"
import * as mlmbox_types_account_pb from '../../../mlmbox/types/account_pb'; // proto import: "mlmbox/types/account.proto"


export class BinaryClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorInfo = new grpcWeb.MethodDescriptor(
    '/mlmbox.client.binary.Binary/Info',
    grpcWeb.MethodType.UNARY,
    google_protobuf_empty_pb.Empty,
    mlmbox_types_account_pb.Binary.Info,
    (request: google_protobuf_empty_pb.Empty) => {
      return request.serializeBinary();
    },
    mlmbox_types_account_pb.Binary.Info.deserializeBinary
  );

  info(
    request: google_protobuf_empty_pb.Empty,
    metadata?: grpcWeb.Metadata | null): Promise<mlmbox_types_account_pb.Binary.Info>;

  info(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: mlmbox_types_account_pb.Binary.Info) => void): grpcWeb.ClientReadableStream<mlmbox_types_account_pb.Binary.Info>;

  info(
    request: google_protobuf_empty_pb.Empty,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: mlmbox_types_account_pb.Binary.Info) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/mlmbox.client.binary.Binary/Info',
        request,
        metadata || {},
        this.methodDescriptorInfo,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/mlmbox.client.binary.Binary/Info',
    request,
    metadata || {},
    this.methodDescriptorInfo);
  }

  methodDescriptorView = new grpcWeb.MethodDescriptor(
    '/mlmbox.client.binary.Binary/View',
    grpcWeb.MethodType.UNARY,
    mlmbox_types_account_pb.PositionView.Team,
    mlmbox_types_account_pb.Binary.View,
    (request: mlmbox_types_account_pb.PositionView.Team) => {
      return request.serializeBinary();
    },
    mlmbox_types_account_pb.Binary.View.deserializeBinary
  );

  view(
    request: mlmbox_types_account_pb.PositionView.Team,
    metadata?: grpcWeb.Metadata | null): Promise<mlmbox_types_account_pb.Binary.View>;

  view(
    request: mlmbox_types_account_pb.PositionView.Team,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: mlmbox_types_account_pb.Binary.View) => void): grpcWeb.ClientReadableStream<mlmbox_types_account_pb.Binary.View>;

  view(
    request: mlmbox_types_account_pb.PositionView.Team,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: mlmbox_types_account_pb.Binary.View) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/mlmbox.client.binary.Binary/View',
        request,
        metadata || {},
        this.methodDescriptorView,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/mlmbox.client.binary.Binary/View',
    request,
    metadata || {},
    this.methodDescriptorView);
  }

  methodDescriptorSetPositionBranchSelectStrategy = new grpcWeb.MethodDescriptor(
    '/mlmbox.client.binary.Binary/SetPositionBranchSelectStrategy',
    grpcWeb.MethodType.UNARY,
    mlmbox_types_account_pb.Binary.BranchSelectStrategy.Request,
    mlmbox_types_account_pb.Binary.Position,
    (request: mlmbox_types_account_pb.Binary.BranchSelectStrategy.Request) => {
      return request.serializeBinary();
    },
    mlmbox_types_account_pb.Binary.Position.deserializeBinary
  );

  setPositionBranchSelectStrategy(
    request: mlmbox_types_account_pb.Binary.BranchSelectStrategy.Request,
    metadata?: grpcWeb.Metadata | null): Promise<mlmbox_types_account_pb.Binary.Position>;

  setPositionBranchSelectStrategy(
    request: mlmbox_types_account_pb.Binary.BranchSelectStrategy.Request,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: mlmbox_types_account_pb.Binary.Position) => void): grpcWeb.ClientReadableStream<mlmbox_types_account_pb.Binary.Position>;

  setPositionBranchSelectStrategy(
    request: mlmbox_types_account_pb.Binary.BranchSelectStrategy.Request,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: mlmbox_types_account_pb.Binary.Position) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/mlmbox.client.binary.Binary/SetPositionBranchSelectStrategy',
        request,
        metadata || {},
        this.methodDescriptorSetPositionBranchSelectStrategy,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/mlmbox.client.binary.Binary/SetPositionBranchSelectStrategy',
    request,
    metadata || {},
    this.methodDescriptorSetPositionBranchSelectStrategy);
  }

}

